import { Dialog, DialogContent, DialogTitle, Grid, Button, FormControlLabel, Radio} from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { cambiarEstadoReclamoEfector } from '../../../../../actions/reclamos/reclamosEfectorActions';

export const CambioEstadoReclamoEfector = (props) => {

const { solicitud, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin } = props;
const [value, setValue] = useState(solicitud?.urgente);
  const dispatch = useDispatch();


  const onSubmitHandler = () => {

    const data = {
      idReclamo: solicitud?.id,
      estado: value
    }
    dispatch(cambiarEstadoReclamoEfector(data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin))
    props.closeModalHandler();
  };


  return (
    <>
    <Dialog
      fullWidth
      maxWidth="xs"
      open={props.open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>
        <span style={{ float: "left" }}>
          Cambio Estado
        </span>
      </DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ alignSelf: 'center', paddingLeft: 16 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <Typography>URGENTE</Typography>
              </div>
            </Grid> */}
             <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center", gap: "2em" }}
              >
                <div>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={value === 0}
                        onChange={() => setValue(0)}
                        value="0"
                        name="radio-button-demo"
                        inputProps={{ 'aria-label': '0' }}
                        style={{ color: 'green' }}
                      />
                    }
                    label="Verde"
                  />

                  <FormControlLabel
                    control={
                      <Radio
                        checked={value === 2}
                        onChange={() => setValue(2)}
                        value="2"
                        name="radio-button-demo"
                        inputProps={{ 'aria-label': '2' }}
                        style={{ color: '#ffcf33' }}
                      />
                    }
                    label="Amarillo"
                  />

                  <FormControlLabel
                    control={
                      <Radio
                        checked={value === 1}
                        onChange={() => setValue(1)}
                        value="1"
                        name="radio-button-demo"
                        inputProps={{ 'aria-label': '1' }}
                        style={{ color: 'red' }}
                      />
                    }
                    label="Rojo"
                  />
                </div>
              </Grid>
          </Grid>
          <div
            style={{
              margin: '1rem 0',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
            }}
          >
            <Button variant="contained" color="primary" onClick={props.closeModalHandler}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={props.disabled}
              color="primary"
            >
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  </>
  )
}
